<ng-container matColumnDef [sticky]="sticky" [stickyEnd]="stickyEnd">
  <mat-header-cell *matHeaderCellDef>
    @if (control) {
    <mat-form-field [linConnectControl]="control" floatLabel="never" class="max-90">
      <ng-content></ng-content>
    </mat-form-field>
    }
  </mat-header-cell>
</ng-container>
